import { render, staticRenderFns } from "./Specialty.vue?vue&type=template&id=00ae1d10&scoped=true"
import script from "./Specialty.vue?vue&type=script&lang=js"
export * from "./Specialty.vue?vue&type=script&lang=js"
import style0 from "./Specialty.vue?vue&type=style&index=0&id=00ae1d10&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00ae1d10",
  null
  
)

export default component.exports